export const partner = {
  "id": 460,
  "status": "draft",
  "name": "VC GmbH",
  "grade": "Платиновый партнер",
  "site": "https://vertical-change.com",
  "phone": "+49-176-999-30403 ; +49-6196-78098-51",
  "address": "Alfred-Herrhausen-Allee 3-5 65760 Eschborn",
  "contact": "Andreas Niese",
  "email": "info@vertical-change.com",
  "competition": null,
  "cert": " ",
  "country": [
    "Germany"
  ],
  "logo": {
    "id": "1c282722-29f9-4781-9f79-54e1f5fe5978",
    "storage": "local",
    "filename_disk": "1c282722-29f9-4781-9f79-54e1f5fe5978.svg",
    "filename_download": "A-Wortbildmarke_Blau 1.svg",
    "title": "A Wortbildmarke Blau 1",
    "type": "image/svg+xml",
    "folder": null,
    "uploaded_by": "7c2cbb1b-cee3-4099-9db2-3bdfd6732557",
    "uploaded_on": "2024-02-01T09:40:26.760Z",
    "modified_by": null,
    "modified_on": "2024-02-01T09:40:26.814Z",
    "charset": null,
    "filesize": "165583",
    "width": null,
    "height": null,
    "duration": null,
    "embed": null,
    "description": null,
    "location": null,
    "tags": null,
    "metadata": null
  },
  "city": {
    "id": 2523,
    "city": "Eschborn",
    "region": "Germany"
  },
  "lang": {
    "code": "en-US",
    "name": "English"
  }
}



// WEBPACK FOOTER //
// ./src/constants/partner.js